const SixAAPrescribedActivities = `
Prescribed activities for export markets development allowance.

6AA. [Omitted by the IT (Thirty-second Amdt.) Rules, 1999, w.e.f. 19-11-1999.]
`;

export default SixAAPrescribedActivities;